export default __webpack_public_path__ + "static/media/CovidApp-Screely.e4c48cab.png";